import { useState, useEffect } from "react";
import { TEAL, CREAM60 } from "../utils/constants";

function PulseLoader({ text }) {
  const [step, setStep] = useState(0);
  useEffect(() => { const id = setInterval(() => setStep(s => s + 1), 600); return () => clearInterval(id); }, []);
  const steps = ["Analyzing role data...", "Mapping task exposure...", "Computing risk factors...", "Generating insights..."];
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 48, gap: 24 }}>
      <div style={{ position: "relative", width: 80, height: 80 }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{ position: "absolute", inset: 0, borderRadius: "50%", border: `2px solid ${TEAL}`, opacity: 0.3, animation: `pulse-ring 2s ease-out ${i * 0.5}s infinite` }} />
        ))}
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 12, height: 12, borderRadius: "50%", background: TEAL }} />
      </div>
      <div style={{ color: CREAM60, fontSize: 14, fontFamily: "'JetBrains Mono', monospace" }}>{text || steps[step % steps.length]}</div>
      <style>{`@keyframes pulse-ring { 0% { transform: scale(0.5); opacity: 0.6; } 100% { transform: scale(2); opacity: 0; } }`}</style>
    </div>
  );
}

export default PulseLoader;
